import React from 'react';
import {connect} from 'react-redux';
import {
    checkUpdates,
    flash,
    getChangedStatus,
    updateCollaborators
} from '../../../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';

class Switch extends React.Component {

    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){

    	let activeState = false;

	    if(this.props.flash){
		    this.props.setFlash(null);
	    }

        if(e.currentTarget.children[0].classList.contains("active")){
            e.currentTarget.children[0].classList.remove("active");
            activeState = false;
        } else {
            e.currentTarget.children[0].classList.add("active");
            activeState = true;
        }


		let contributorsToUpdate = [];
		let {updateCollaborators, collaboratorId} = this.props;
		let newCollaboratorToUpdate = true;

		if(updateCollaborators.length > 0){

			this.props.findCollaborators.collaborators.forEach(collaborator => {
				updateCollaborators.forEach(updateCollaborator => {

					if(updateCollaborator.id){
						if(collaborator.id === updateCollaborator.id){

							/*
							*  Collaborator is inside the collaborators to update
							* */

							if(collaborator.id === collaboratorId){

								newCollaboratorToUpdate = false;

								/*
								*  Collaborator is the one we have clicked on
								* */

								let collaboratorToUpdate = {
									groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
									id: updateCollaborator.id,
									email: updateCollaborator.email,
									permission: updateCollaborator.permission,
									type: updateCollaborator.type,
									addToContact: activeState,
									toRemove: updateCollaborator.toRemove,
								};

								if(
									collaborator.id === collaboratorToUpdate.id &&
									collaborator.email === collaboratorToUpdate.email &&
									collaborator.permission === collaboratorToUpdate.permission &&
									collaborator.type === collaboratorToUpdate.type &&
									collaborator.addToContact === collaboratorToUpdate.addToContact &&
									collaborator.toRemove === collaboratorToUpdate.toRemove
								){
									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.id !== updateCollaborator.id)
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								} else {
									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.id !== updateCollaborator.id),
										collaboratorToUpdate
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								}

							}

						}
					} else {

						if(collaborator.id === collaboratorId){

							if(collaborator.permission === "OWNER"){
								newCollaboratorToUpdate = false;

								let collaboratorToUpdate = {
									groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
									permission: updateCollaborator.permission,
									addToContact: activeState,
									toRemove: updateCollaborator.toRemove,
								};

								if(
									collaborator.permission === collaboratorToUpdate.permission &&
									collaborator.addToContact === collaboratorToUpdate.addToContact &&
									collaborator.toRemove === collaboratorToUpdate.toRemove
								){
									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.hasOwnProperty("id"))
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								} else {
									contributorsToUpdate = [
										...updateCollaborators.filter((item) => item.hasOwnProperty("id")),
										collaboratorToUpdate
									];
									this.props.setUpdateCollaborators(contributorsToUpdate);
								}
							} else {
								return null;
							}

						}

						/*
						* That means something on the current OWNER have been planned to change on that it will be canceled
						* */

						//let updateFilteredCollaborators = updateCollaborators.filter((updateCollaborator) => updateCollaborator.id);

						//this.props.setUpdateCollaborators(updateFilteredCollaborators);

					}


				});

				if(newCollaboratorToUpdate){
					if (collaborator.id === collaboratorId) {

						if(collaboratorId === this.props.profile.id && this.props.selectedContactsGroup.permission === "OWNER"){
							this.props.setUpdateCollaborators(
								[
									...updateCollaborators,
									{
										groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
										permission: collaborator.permission,
										addToContact: activeState,
										toRemove: collaborator.toRemove
									}
								]
							)
						} else {
							this.props.setUpdateCollaborators(
								[
									...updateCollaborators,
									{
										groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
										id: collaborator.id,
										email: collaborator.email,
										permission: collaborator.permission,
										type: collaborator.type,
										addToContact: activeState,
										toRemove: collaborator.toRemove
									}
								]
							)
						}

					}
				}

			});

		} else {

			this.props.findCollaborators.collaborators.forEach(collaborator => {

				if (collaborator.id === collaboratorId) {
					if(collaboratorId === this.props.profile.id && this.props.selectedContactsGroup.permission === "OWNER"){
						this.props.setUpdateCollaborators([{
							groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
							permission: collaborator.permission,
							addToContact: activeState,
							toRemove: collaborator.toRemove
						}])
					} else {
						this.props.setUpdateCollaborators([{
							groupId: this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
							id: collaborator.id,
							email: collaborator.email,
							permission: collaborator.permission,
							type: collaborator.type,
							addToContact: activeState,
							toRemove: collaborator.toRemove
						}])
					}
				}

			})
		}

        //this.props.checkUpdates();
    }

    render(){
        return (
            <div onClick={this.handleClick} className="switch" data-collaborator-id={this.props.collaboratorId}>
                {
                    this.props.findCollaborators.collaborators[this.props.index].addToContact
                        ?
                            <div className={`bg active`}>
                                <div className="cursor"/>
                            </div>
                        :
                            <div className={`bg`}>
                                <div className="cursor"/>
                            </div>
                }

            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		flash : state.sharingDetailsReducer.flash,
		getSharingDetailsPopup : state.sharingDetailsReducer.getSharingDetailsPopup,
		profile: state.profileReducer.getProfile,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
        checkUpdates : () => {
            dispatch(checkUpdates())
        },
		setFlash : (array) => {
			dispatch(flash(array))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Switch);
